export const DISMISS_DRAG_HINT_PROPERTY_SIDE_PANEL =
  'DISMISS_DRAG_HINT_PROPERTY_SIDE_PANEL';

export const SET_CALLABLE_FLOW_LIST_FILTER_TYPE =
  'SET_CALLABLE_FLOW_LIST_FILTER';
export const SET_HTTP_TRIGGER_LIST_FILTER_TYPE = 'SET_HTTP_TRIGGER_LIST_FILTER';
export const SET_CUSTOM_STEP_LIST_FILTER_TYPE = 'SET_CUSTOM_STEP_LIST_FILTER';

export function dismissDragHintOnPropertySidePanel() {
  return { type: DISMISS_DRAG_HINT_PROPERTY_SIDE_PANEL };
}

export function setHttpTriggerListFilterType(filterType) {
  return { type: SET_HTTP_TRIGGER_LIST_FILTER_TYPE, payload: filterType };
}

export function setCustomStepListFilterType(filterType) {
  return { type: SET_CUSTOM_STEP_LIST_FILTER_TYPE, payload: filterType };
}

export function setCallableFlowListFilterType(filterType) {
  return { type: SET_CALLABLE_FLOW_LIST_FILTER_TYPE, payload: filterType };
}
